import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// Slice
import { setActiveLoginModal, setLms } from '../../app/features/userSlice';
// Components
import Container from '../Container';
// Services
import { autenticationURL } from '../../services/Login/getInstitutionData';
// Images
import { IoMdClose } from 'react-icons/io';
import imageLogin from '../../Images/Login/ImageModal.webp';
// Images
import logoHeaderHome from '../../Images/logo/logo_OlibBlack.svg';
import AquinoImage from '../../Images/Login/Modal/Aquino.png';
import iconModal from '../../Images/Login/Modal/IconModal.svg';
// Styles
import './LoginModal.css';
// Translate
import { useTranslation } from 'react-i18next';

const LoginModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { institutionCode, assignedLogin, isActive } = useSelector(
    (state) => state.institution
  );

  const loginButtonName = (name) => {
    const isUnique = name === 'unique';
    const baseName = isUnique
      ? institutionCode === 'CMVC'
        ? `${t('Login with')} moodle`
        : t('Unique login')
      : `${t('Login with')} ${name}`;
    return baseName;
  };

  const getLogin = (login) => {
    dispatch(setActiveLoginModal(false));
    if (login === 'unique' || login === 'talent') {
      navigate('login');
    } else if (login === 'canvas' || login === 'moodle') {
      dispatch(setLms(login));
      window.location.href = autenticationURL(login, institutionCode);
    } else if (login === 'moodle 2.9') {
      dispatch(setLms('moodle 2.9'));
      window.location.href = autenticationURL(login, `${institutionCode}_2`);
    } else if (login === 'digitalocean') {
      dispatch(setLms(login));
      window.location.href = autenticationURL(login, institutionCode);
    } else if (login === 'blackboard') {
      dispatch(setLms(login));
      window.location.href = autenticationURL(login, institutionCode);
    } else if (login === 'populi') {
      dispatch(setLms(login));
      window.location.href = autenticationURL(login, institutionCode);
    } else if (login === 'wordpress') {
      navigate('login-with-wordpress');
    }
  };

  const formatProviders = (providers) => {
    if (!providers || providers.length === 0) return '';

    const labels = providers.map((p) => (p === 'unique' ? 'unique login' : p));

    if (labels.length === 1) return labels[0];
    if (labels.length === 2) return `${labels[0]} or ${labels[1]}`;

    return `${labels.slice(0, -1).join(', ')}, or ${labels.at(-1)}`;
  };

  return (
    <div className='loginHomeModal'>
      <Container>
        <div className={isActive ? 'modal-content': 'modal-content Deactivate' }>
          <button
            className='closeButton'
            onClick={() => dispatch(setActiveLoginModal(false))}
          >
            <IoMdClose />
          </button>

          {isActive ? (
            <>
              <div className='imageContent'>
                <img src={imageLogin} alt='Modal login' />
                <div className='imageText'>
                  <p>
                    Your Unified Portal to <b>Aquinas Online Library</b>
                  </p>
                  <p>
                    Find books, scholarly articles, and exclusive resources by
                    exploring hundreds of library databases worldwide. <br />
                    Thanks to our built-in artificial intelligence, perform
                    faster, more accurate searches tailored to your needs
                  </p>
                </div>
              </div>

              <div className='textContent'>
                <img src={logoHeaderHome} alt='logo Aquinas' />
                <p>
                  Log in to the library using your{' '}
                  <b>{formatProviders(assignedLogin)} account credentials.</b>
                </p>

                <div className='loginButtonModalContainer'>
                  {assignedLogin?.map((login, i) => (
                    <button
                      onClick={() => getLogin(login)}
                      key={i}
                      className='loginButtonModal'
                    >
                      {loginButtonName(login)}
                    </button>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div>
              <div className='noActiveContent'>
                <img src={AquinoImage} alt='logo Aquinas' />
                <div className='info'>
                  <img src={iconModal} alt='icon' />
                  <p>We want to see you back</p>
                </div>
              </div>
              <p className='infoText'>
                We just wanted to remind you that <b>your annual subscription has expired</b>. It was a pleasure having you this year. If you enjoyed your experience, please renew your subscription and continue enjoying all the benefits of our bookstore. We look forward to seeing you again!
              </p>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default LoginModal;
